import { Grid, Typography } from "@mui/material";
import React from "react";
import CardEl from "../../Elements/CardEl";
import { useSelector } from "react-redux";

import { optionsBranch } from "../../data/branch-data";
import { convertDateToString2 } from "../../utils/function";


const ReviewFormEl = ({ hooksForm, internType, optionsCompany }) => {
  const profile = useSelector((state) => state.profileReducer.profile);
  const { watch, register } = hooksForm;
  const watchInternType = watch("intern-type");

  const matchOptions = (options, value) => {
    const match = options.find((item) => item.value == value);

    return match ? match.label : "-";
  };

  const generateType = () => {
    let text = "";

    if (watchInternType == 1) {
      text = "ฝึกงานภาคฤดูร้อน (2 เดือน)";
    } else if (watchInternType == 2) {
      text = "สหกิจศึกษา (4 เดือน)";
    } else if (watchInternType == 3) {
      text = "ฝึกงานภาคฤดูร้อน และสหกิจศึกษา (6 เดือน)";
    }

    return text;
  };

  return (
    <div className="container-fluid p-0">
      <div id="section-to-print">
        <div className="card">
          <div className="card-body m-sm-3 m-md-5">
            <h1 className="h3 mb-3">ข้อมูลส่วนตัว</h1>
            <div className="text-center text-md-start my-4">
              {profile && profile.m_role === "student" && (
                <img
                  src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${profile.id}`}
                  width="120px"
                />
              )}
              {/* <img
                src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=55050422`}
                width="120px"
              /> */}
            </div>

            <div className="row g-4">
              <div className="col-6">
                <div className="text-muted">ชื่อ - นามสกุล</div>
                <strong>{profile?.name ?? "-"}</strong>
              </div>
              <div className="col-6 text-md-right">
                <div className="text-muted">รหัสนิสิต</div>
                <strong>{profile?.id ?? "-"}</strong>
              </div>

              <div className="col-6 text-md-right">
                <div className="text-muted">สาขาวิชา</div>
                <strong>
                  {/* {optionsBranch.find((item) => item.value == 1)?.label} */}
                  {profile ? matchOptions(optionsBranch, profile.b_id) : "-"}
                </strong>
              </div>
              <div className="col-6">
                <div className="text-muted">เกรดเฉลี่ยสะสม</div>
                <strong>{(+profile?.gpa).toFixed(2) ?? "-"}</strong>
              </div>
              <div className="col-6">
                <div className="text-muted">เบอร์โทร</div>
                <strong>{profile?.st_mail ?? "-"}</strong>
              </div>
              <div className="col-6 text-md-right">
                <div className="text-muted">อีเมล</div>
                <strong>{profile?.st_tel ?? "-"}</strong>
              </div>
            </div>
            <hr className="my-4" />
            <h1 className="h3 mb-3">ข้อมูลสถานประกอบการ</h1>
            <div className="row g-4">
              <div className="col-6">
                <div className="text-muted">สถานประกอบการ</div>
                <strong>
                  {matchOptions(optionsCompany, watch("company"))}
                </strong>
              </div>
              {/* <div className="col-6 text-md-right">
                <div className="text-muted">ที่อยู่</div>
                <strong>  {matchOptions(optionsCompany, watch("company"))} </strong>
              </div> */}
              <div className="col-6">
                <div className="text-muted">ชื่อผู้ประสานงาน</div>
                <strong>{watch("name")}</strong>
              </div>
              <div className="col-6 text-md-right">
                <div className="text-muted">ตำแหน่ง</div>
                <strong>{watch("position")}</strong>
              </div>
              <div className="col-6">
                <div className="text-muted">เบอร์โทร</div>
                <strong>{watch("tel") ?? "-"}</strong>
              </div>
              <div className="col-6 text-md-right">
                <div className="text-muted">อีเมล</div>
                <strong>{watch("email") ?? "-"}</strong>
              </div>
            </div>
            <hr className="my-4" />
            <h1 className="h3 mb-3">รายละเอียดการฝึกงาน</h1>
            <div className="row g-4">
              <div className="col-6">
                <div className="text-muted">ประเภทการฝึกงาน</div>
                <strong>{generateType() ?? "-"}</strong>
              </div>
              <div className="col-6 text-md-right">
                <div className="text-muted">ช่วงเวลา</div>
                <strong>
                  <span>
                    <span> {convertDateToString2(new Date(watch("startDate")).toLocaleDateString())}  </span>
                  
                    <span> - </span>
                    <span>{convertDateToString2(new Date(watch("endDate")).toLocaleDateString())} </span>
                  </span>
                </strong>
              </div>
            </div>
            <div className="col-12 mt-4 text-md-right d-flex">
              <input
                type="checkbox"
                className="form-check me-2"
                {...register("check1")}
              />

              <div className="text-muted">
                ข้าพเจ้าได้อ่านเกณฑ์การฝึกงานภาคฤดูร้อนและสหกิจศึกษาสำหรับนักศึกษาปริญญาตรีตามประกาศคณะวิศวกรรมศาสตร์
                มหาวิทยาลัยบูรพา ที่{" "}
                <a
                  href="https://drive.google.com/file/d/1-Oiw5Yyo6lg8qOOh8sk73TNcg6oG7xJ4/view?usp=sharing"
                  target="_blank"
                >
                  113/2565
                </a>
              </div>
            </div>
            <div className="col-12 text-md-right d-flex">
              <input
                type="checkbox"
                className="form-check me-2"
                {...register("check2")}
              />

              <div className="text-muted">
                ข้าพเจ้าได้ผ่านเกณฑ์การฝึกงานภาคฤดูร้อนและสหกิจศึกษา
                ตามที่ระบุไว้ตามสาขาวิชา
              </div>
            </div>
            <div className="col-12 text-md-right d-flex">
              <input
                type="checkbox"
                className="form-check me-2"
                {...register("check3")}
              />

              <div className="text-muted">
                ให้นิสิตมารับหนังสือขอความอนุเคราะห์ฝึกงาน
                และจะนำไปส่งด้วยตัวเอง
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="text-center my-3">
        <a href="#" className="btn btn-primary" onClick={() => window.print()}>
          พิมพ์เอกสาร
        </a>
      </div> */}
    </div>
  );
};

export default ReviewFormEl;
